const { createSlice } = require("@reduxjs/toolkit");
 
const initialState = {
    privileges: {},
    canCreateJourney: false,
};
 
const PrivilegesSlice = createSlice({
    name: 'privileges',
    initialState,
    reducers: {
        setPrivileges: (state, action) => {
            state.privileges = action.payload;
        },
        setCanCreateJourney: (state, action) => {
            state.canCreateJourney = action.payload;
        },
    },
});
 
export const { setPrivileges, setCanCreateJourney } = PrivilegesSlice.actions;
export default PrivilegesSlice.reducer;